import type { CareerPathFitLevel } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import type { CareerPathWithScore } from '@backrs_ui/grow-ui/src/models/models';

const MODAL = appStrings.modules.careerPath.summaryPage.whatIsACareerPathModal;

export const useAgentContext = (
  careerPathSuggestions: CareerPathWithScore[] | undefined,
  fitLabelMap: Record<string, CareerPathFitLevel>,
) => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Strong Fit Paths',
    description:
      'Shows career path suggestions ranked by blueprint fit. Includes a segmented bar chart of career categories and a grid of career path cards with fit level badges (Strong Fit / Medium Fit / Low Fit).',
    detail: `"What is a Career Path?" modal — ${MODAL.header.title}: ${MODAL.header.subtitle}. ${MODAL.topLeftSection.title}: ${MODAL.topLeftSection.description} ${MODAL.bottomRightSection.title}: ${MODAL.bottomRightSection.description}`,
  });

  useRegisterAgentContext({
    kind: 'list',
    description: "Career path suggestions with fit levels based on the user's blueprint",
    data: {
      fitLabelMap,
      careerPaths: careerPathSuggestions ?? [],
    },
  });
};
